import styled from 'styled-components';
import { rem } from 'polished';
import Container from '@/components/Global/Container';

export const TenantPortingContainer = styled(Container)``;

export const TenantPortingHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('15px')};
  > span,
  > h3:last-child {
    margin-bottom: ${rem('15px')};
  }

  svg {
    width: ${rem('80px')};
    height: ${rem('80px')};
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: ${rem('10px')} ${rem('10px')} ${rem('10px')} 0;

    > span,
    > h3:last-child {
      margin-bottom: ${rem('30px')};
    }

    svg {
      width: ${rem('88px')};
      height: ${rem('88px')};
    }
  }
`;

export const TenantPortingItemsWrapper = styled.div`
  padding: ${rem('30px')} 0;
  width: 100%;

  > h2 {
    color: var(--mineShaft);
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      margin-bottom: ${rem('30px')};
    }
  }
`;
